<template>
  <v-container fluid class="accent lighten-4">
    <v-row align="center">
      <v-col
        cols="12"
        >
        <h2
          class="accent--text text-center my-3 display-3"
        >Speakers</h2>
      </v-col>
      <v-col>
        <div class="text-center">
          <v-row class="mx-6">
            <v-col
            v-for="speaker in speakers"
            :key="speaker.name"
            md="4"
            sm="12"
            elevation="2"
            >
              <v-card
                class="mx-auto fill-height"
                flat
                outlined
                width="345"
              >
                <v-img
                  class="white--text"
                  gradient="to top, rgba(0, 0, 0, 0.6) 0%, transparent 72px"
                  height="300px"
                  :src="speaker.src"
                >
                  <v-card-title class="align-end fill-height">{{speaker.name}}</v-card-title>
                </v-img>
                <v-card-title></v-card-title>
                <v-chip
                  class="ma-1"
                  :color="speaker.track==='Startup' ? 'success' : 'purple lighten-1'"
                  outlined
                  small
                >
                  {{speaker.track}}
                </v-chip>

                <v-chip
                  class="ma-1"
                  :color="speaker.tcolor"
                  dark
                  small
                >{{speaker.topic}}
                </v-chip>
                <v-card-text>
                  <p>{{speaker.position}}</br> {{speaker.company}}</p>
                  <p class="title">{{speaker.session}}</p>
                </v-card-text>
                <v-card-actions>
                  <v-btn icon class="ma-1"
                    color="success"
                    v-if="speaker.website"
                    :href="speaker.website">
                    <v-icon>mdi-link-variant</v-icon>
                  </v-btn>
                  <v-btn icon class="ma-1"
                    color="success"
                    v-if="speaker.linkedin"
                    :href="speaker.linkedin">
                    <v-icon>mdi-linkedin</v-icon>
                  </v-btn>
                  <v-btn icon class="ma-1"
                  color="success"
                  v-if="speaker.twitter"
                  :href="speaker.twitter">
                    <v-icon>mdi-twitter</v-icon>
                  </v-btn>
                  <v-btn icon class="ma-1"
                  color="success"
                  v-if="speaker.email"
                  :href="speaker.email">
                    <v-icon>mdi-email-outline</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

  name: 'LandingSpeaker',

  data() {
    return {
      speakers: [
        {
          name: 'Gina Bongiovi',
          src: require('../assets/speakers/GinaBongiovi.jpg'),
          position: 'Corporate Consigliere',
          company: 'Bongiovi Law',
          website: 'http://www.bongiovilaw.com',
          session: 'Building a Bridge between Law and Tax',
          topic: 'Regulatory & Compliance',
          tcolor: 'light-green lighten-1',
          track: 'Small Business',
          linkedin: 'http://www.linkedin.com/in/lawyergina',
          twitter: 'http://twitter.com/lawyergina',
        },
        {
          name: 'Rebecca Warnick, CPA',
          src: require('../assets/speakers/RebeccaWarnick.jpg'),
          position: 'Founder / Principal',
          company: 'The Warnick Group',
          website: 'https://thewarnickgroup.com/',
          session: 'Building a Bridge between Law and Tax',
          topic: 'Regulatory & Compliance',
          tcolor: 'light-green lighten-1',
          track: 'Small Business',
          linkedin: 'https://www.linkedin.com/in/rebeccawarnick/',
        },
        {
          name: 'Evynn McFalls',
          src: require('../assets/speakers/EvynnMcFalls.jpg'),
          position: 'Director of Insights & Strategy',
          company: 'The Abbi Agency',
          website: 'http://www.TheAbbiAgency.com/',
          session: 'Building your Storybrand',
          topic: 'Marketing & Distribution',
          tcolor: 'orange darken-1',
          track: 'Startup',
          linkedin: 'http://www.linkedin.com/in/EvynnMcFalls',
          twitter: 'http://twitter.com/EvynnMcFalls',
        },
        {
          name: 'Colin Loretz',
          src: require('../assets/speakers/ColinLoretz.jpg'),
          position: 'Founder',
          company: 'Reno Collective',
          session: 'Building a Software MVP (Minimum Viable Product)',
          topic: 'Ideas & Product',
          tcolor: 'blue',
          track: 'Startup',
          twitter: 'https://www.twitter.com/colinloretz',
        },
        {
          name: 'Dana Berggren',
          src: require('../assets/speakers/DanaBerggren.jpg'),
          position: 'Broker/Owner',
          company: 'Berggren Commercial Real Estate',
          session: 'Setting Up Shop: Where will you office?',
          topic: 'Operations',
          tcolor: 'cyan darken-3',
          track: 'Small Business',
          website: 'https://www.BerggrenCRE.com',
          twitter: 'https://www.twitter.com/BerggrenCRE',
          facebook: 'https://www.facebook.com/berggrenCRE/',
        },
        {
          name: 'Heather Wilde',
          src: require('../assets/speakers/HeatherWilde.jpg'),
          position: 'CTO',
          company: 'ROCeteer',
          session: 'Elephant Spotting: How to Define the Right Metrics for Your Company Success',
          topic: 'Operations',
          tcolor: 'cyan darken-3',
          track: 'Startup',
          website: 'http://roceteer.com',
          twitter: 'https://twitter.com/heathriel',
        },
        {
          name: 'Monica Coburn',
          src: require('../assets/speakers/MonicaCoburn.png'),
          position: 'CEO and Chief Success Strategist',
          company: 'Nevada Business Advisors',
          website: 'https://nevadabusinessadvisors.com',
          session: "Let's Talk about Money and Growth: Financing your Business",
          topic: 'Growth',
          tcolor: 'green',
          track: 'Small Business',
          linkedin: 'https://www.linkedin.com/in/monicacoburn/',
        },
        {
          name: 'Bill Arent CEcD',
          src: require('../assets/speakers/BillArent.jpg'),
          position: 'Director, Economic & Urban Development',
          company: 'City of Las Veags',
          session: 'Growing Business at the International Innovation Center @ Vegas',
          topic: 'Growth',
          tcolor: 'green',
          track: 'Small Business',
          linkedin: 'https://www.linkedin.com/in/bill-arent-63b254a/',
        },
        {
          name: 'Jimmy Jacobson',
          src: require('../assets/speakers/JimmyJacobson.jpg'),
          position: 'Partner/Co-founder',
          company: 'Codingscape',
          website: 'http://www.codingscape.com',
          session: 'Growing your Enterprise with Technology',
          topic: 'Operations',
          tcolor: 'cyan darken-3',
          track: 'Small Business',
          linkedin: 'https://www.linkedin.com/in/jimmyjacobson/',
        },
      ],
    };
  },
};
</script>
